/*
src/ui-panels/MoonPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {FormGroup, Slider} from '@blueprintjs/core';

import {ColorPicker} from '../ui-misc/ColorPicker.js';
import {ImagesList} from '../ui-misc/ImagesList.js';


export class MoonPanel extends React.Component {


	constructor(props) {
		super(props);

		// Params are specific properties of the ParamsManager that use the getParams and setParams methods.
		// The paramsOfInterest object is used to fetch only the params used by this panel.
		// The propertiesOfInterest array includes the names of all params of interest, plus any additional
		//	properties of interest that are not params. It is used to determine if the panel needs to be re-rendered.
		// Examples: width is a param, but sunImage is not. Both are properties.
		this._paramsOfInterest = {moonPosition: null, moonSize: null, moonNoImageColor: null};
		this._propertiesOfInterest = ['moonImage'];
		for (const key in this._paramsOfInterest) {
			this._propertiesOfInterest.push(key);
		}

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSetParams = this.handleSetParams.bind(this);
		this.handleSelectImage = this.handleSelectImage.bind(this);
		
		this._paramsMan = this.props.workspace.getParamsManager();
		this._moonImageBank = this.props.workspace.getMoonImageBank();

		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);
		this._moonImageBank.registerCallback('change', this.forceRender);

		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {
		// Re-render only if any of the properties of interest have changed.
		for (const key of this._propertiesOfInterest) {
			if (data.newValues.hasOwnProperty(key)) {
				this.forceRender();
				return;
			}
		}
	}

	handleSetParams(p) {
		this._paramsMan.setParams(p);
	}

	handleSelectImage(image) {
		this._paramsMan.setMoonImage(image);
	}


	render() {
	
		let params = this._paramsMan.getParams(this._paramsOfInterest);

		return (
			<div style={{maxWidth: "750px", margin: "30px auto"}}>

				<ColorPicker label="Moon No-Image Color" color={params.moonNoImageColor} allowAlpha={false}
					onChange={value => this.handleSetParams({moonNoImageColor: value})} />

				<FormGroup label="Moon Position" labelFor="moon-position-slider">
					<Slider id="moon-position-slider" min={0.0} max={1.0} stepSize={0.001} labelStepSize={0.1}
						onChange={value => this.handleSetParams({moonPosition: value})} value={params.moonPosition} />
				</FormGroup>

				<FormGroup label="Moon Size" labelFor="moon-size-slider">
					<Slider id="moon-size-slider" min={0.01} max={0.1} stepSize={0.001} labelStepSize={0.02}
						onChange={value => this.handleSetParams({moonSize: value})} value={params.moonSize} />
				</FormGroup>
		
				<ImagesList bank={this._moonImageBank}
					onSelect={this.handleSelectImage}
					selected={this._paramsMan.getMoonImage()}
				/>
			
			</div>
		);
	}

}


